/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Art des Haushalts)     * `Single`        - german: Single ohne Kinder   * `Partner`       - german: Partner ohne Kinder   * `SingleParent`  - german: alleinerziehend   * `Family`        - german: Familie
 */
export const HouseholdKind = {
  Single: 'Single',
  Partner: 'Partner',
  SingleParent: 'SingleParent',
  Family: 'Family',
} as const;
export type HouseholdKind = (typeof HouseholdKind)[keyof typeof HouseholdKind];
